import GtmMobileUserFeeds from "mobile/initializers/gtm_mobile_user_feeds";
import GtmMobileWatchPage from "mobile/initializers/gtm_mobile_watch_page";
import { isMobile } from "shared/vidio_helpers";
import SocialTracker from "shared/social_tracker";
import $ from "jquery";

export default class SocialModal {
  constructor(
    triggerSelector,
    containerSelector,
    tracker = SocialTracker.createNull()
  ) {
    this.modalSelector = "#vidio-social-modal";
    this.closeModalSelector = ".js-social-modal__close";
    this.overlaySelector = ".js-social-modal__overlay";
    this.triggerSelector = triggerSelector;
    this.containerSelector = containerSelector;
    this.tracker = tracker;
  }

  init() {
    this.bindOpenSocialModal();
    this.bindCloseSocialModal();
    this.bindShareUrl();
  }

  bindOpenSocialModal() {
    const $trigger = $(this.triggerSelector);
    $trigger.each((_index, button) => {
      $(button).on("click touchend", this.onButtonClick.bind(this));
    });
  }

  bindCloseSocialModal() {
    $(this.closeModalSelector).on("click", (e) => {
      e.preventDefault();
      this.closeSocialModal();
    });

    $(this.overlaySelector).on("click", (e) => {
      e.preventDefault();
      this.closeSocialModal();
    });
  }

  bindShareUrl() {
    $("body").on("click", ".share--text", (e) => {
      e.preventDefault();
      this.select();
    });
  }

  bindClickToTrack() {
    let tracker = this.tracker;
    let shareButtons = $(this.modalSelector).find(".share");
    shareButtons.each((_index, button) => {
      $(button).on("click", () => {
        let url = this.shareButtonUrl(button);
        if (url) {
          tracker.trackShareClick(button.textContent.toLowerCase(), url);
        }
      });
    });
  }

  onButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    let dataTarget = $(e.target).data("target");
    let dataSource = $(e.target).data("source")
      ? $(e.target).data("source")
      : $(e.currentTarget).data("source");
    let dataVideoId = $(e.target).data("video-id");
    let dataTargetUrl = $(e.target).data("target-url")
      ? $(e.target).data("target-url")
      : $(e.currentTarget).data("target-url");
    let modalContentSelector = dataTarget ? dataTarget : this.containerSelector;

    const isShareButton = e.target.className.indexOf("share")

    if (!isShareButton) document.getElementsByTagName("body")[0].style.overflow = "hidden";

    this.openNativeShare(
      dataSource,
      dataTargetUrl,
      this.modalSelector,
      modalContentSelector
    );

    this.sendGtmPopupImpression(dataSource, dataVideoId);
    this.sendGtmPopupShareButtonClick(dataSource);

    // bind click always called because the DOM always replaced when showing modal
    // (see line: 85, openSocialModal)
    this.bindClickToTrack();
  }

  async openNativeShare(
    source,
    targetUrl,
    modalSelector,
    modalContentSelector
  ) {
    var utm_content = source;
    var shareData = {
      url: targetUrl,
    };
    if (source != null) {
      if (source == "vod-watchpage") {
        utm_content = "watchpage";
      }

      if (targetUrl != null)
        shareData.url +=
          "?utm_source=referral&utm_medium=share&utm_content=" + utm_content;
    }
    const tracker = this.tracker;

    if (navigator.share) {
      await navigator.share(shareData);
      tracker.trackShareClick("native", shareData.url);
    } else {
      this.openSocialModal(
        modalSelector,
        modalContentSelector,
        source,
        targetUrl
      );
    }
  }

  openSocialModal(modalSelector, modalContentSelector, source, targetUrl) {
    let element = $(modalContentSelector).html();

    $(modalSelector).find(".social-modal__content").html(element);
    if (source == "channel" && targetUrl) {
      this.addUtmToSocialButton(modalSelector, "channel", targetUrl);
    }

    if (isMobile()) {
      $(modalSelector).addClass("b-popup--show");
    } else {
      $(modalSelector).addClass("social-modal__show");
    }

    if (window.player) {
      window.player.tech().pause();
    }
  }

  closeSocialModal() {
    if (isMobile()) {
      $(this.modalSelector).removeClass("b-popup--show");
    } else {
      $(this.modalSelector).removeClass("social-modal__show");
    }

    document.getElementsByTagName("body")[0].style.removeProperty("overflow");

    if (window.player) {
      window.player.tech().play();
    }
  }

  addUtmToSocialButton(modal, utmContent, targetUrl) {
    var shareUrl = targetUrl;
    let facebookButton = $(modal).find(
      ".social-modal__item-body.share--facebook"
    );
    let twitterButton = $(modal).find(
      ".social-modal__item-body.share--twitter"
    );
    let utm = "?utm_source=referral";
    let utmMediumFacebook = "&utm_medium=share-facebook";
    let utmMediumTwitter = "&utm_medium=share-twitter";
    shareUrl += `${utm}&utm_content=${utmContent}`;
    $(facebookButton).attr("data-utm-url", `${shareUrl}${utmMediumFacebook}`);
    $(facebookButton).attr(
      "href",
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        shareUrl + utmMediumFacebook
      )}`
    );
    $(twitterButton).attr("data-utm-url", `${shareUrl}${utmMediumTwitter}`);
    $(twitterButton).attr(
      "href",
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        shareUrl + utmMediumTwitter
      )}`
    );
  }

  sendGtmPopupImpression(source, videoId) {
    if (source == "feeds") {
      GtmMobileUserFeeds.pushWithType(
        "impression",
        "vod." + videoId,
        "share",
        "following"
      );
    } else if (source == "vod-watchpage") {
      var properties = {
        event: "impression",
        feature_name: "share",
        feature_location: "watchpage",
        feature_type: "vod." + videoId,
      };
      GtmMobileWatchPage.sendDataLayer(properties);
    }
  }

  sendGtmPopupShareButtonClick(source) {
    if (source == "feeds") {
      GtmMobileUserFeeds.bindShareButtonClick("facebook");
      GtmMobileUserFeeds.bindShareButtonClick("line");
      GtmMobileUserFeeds.bindShareButtonClick("twitter");
      GtmMobileUserFeeds.bindShareButtonClick("google-plus");
      GtmMobileUserFeeds.bindShareButtonClick("whatsapp");
      GtmMobileUserFeeds.bindShareButtonClick("link");
    } else if (source == "vod-watchpage") {
      GtmMobileWatchPage.bindShareButtonClick("facebook");
      GtmMobileWatchPage.bindShareButtonClick("line");
      GtmMobileWatchPage.bindShareButtonClick("twitter");
      GtmMobileWatchPage.bindShareButtonClick("google-plus");
      GtmMobileWatchPage.bindShareButtonClick("whatsapp");
      GtmMobileWatchPage.bindShareButtonClick("link");
    }
  }

  shareButtonUrl(button) {
    return $(button).data("utm-url") || $(button).data("clipboard-text");
  }
}
